import { apiRequest } from 'api/apiClient';

const fetchEvents = async ({ page, pageSize, search, ordering, filters } = {}) => {
  const response = await apiRequest('GET', '/v1/events', null, {
    params: {
      ...(page ? { page } : {}),
      ...(pageSize ? { page_size: pageSize } : {}),
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchEvent = async (uid) => {
  const response = await apiRequest('GET', `/v1/events/${uid}`, null);
  return response;
};

const fetchEventsUsage = async (regionUid) => {
  const response = await apiRequest('GET', `v1/event-usage/${regionUid}`, null);
  return response;
};

const EVENTS_QUERIES = {
  FETCH_EVENTS: fetchEvents,
  FETCH_EVENT: fetchEvent,
  FETCH_EVENTS_USAGE: fetchEventsUsage,
};

export default EVENTS_QUERIES;
